import { render, staticRenderFns } from "./ViewBikeDetails.vue?vue&type=template&id=21751430&lang=pug&"
import script from "./ViewBikeDetails.vue?vue&type=script&lang=js&"
export * from "./ViewBikeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports